import { Root as ButtonRoot } from '../Button/styles';
import { css } from '@linaria/core';
export const Root = {
    base: css ``,
};
export const MainElementContainer = {
    base: css `
		&& > * {
			float: none;
		}
	`,
};
export const ListWrapper = {
    base: css `
		border-radius: var(--contextMenu-corner-radius-all);
		background: rgb(var(--contextMenu-color-background));
		box-shadow: 0 var(--contextMenu-shadow-offset-y) var(--contextMenu-shadow-blur)
			rgba(var(--contextMenu-color-shadow-alpha));
	`,
    hasAnimations: css `
		transform: scale(0);
		transition-timing-function: var(--global-ease-out);
		transition-duration: 200ms;
		transition-property: opacity, transform;
	`,
};
export const ContextContainer = {
    base: css `
		position: relative;
		z-index: var(--global-z-index-contextMenu);
		outline: none;
		ul {
			scrollbar-width: none;

			overflow: hidden;
			overflow-y: scroll;
			display: flex;
			flex-direction: column;
			gap: 3px;

			max-height: 70vh;
			margin: 0;
			padding: 8px;

			list-style: none;

			outline: none;
			&::-webkit-scrollbar {
				display: none;
			}

			.${ButtonRoot.base} {
				width: 100%;
				text-align: left;

				svg {
					path {
						fill: rgb(var(--button-square-color-icon-idle)) !important;
					}
				}

				&.active {
					svg {
						path {
							fill: rgb(var(--button-square-color-background-hover)) !important;
						}
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						svg {
							path {
								fill: rgb(var(--button-square-color-icon-hover)) !important;
							}
						}
					}
				}
			}
		}
	`,
    hasDefaultAnimation: css `
		&[data-status='open'] {
			.${ListWrapper.base} {
				transform: scale(1) translateY(0);
			}
		}
		&[data-status='initial'],
		&[data-status='close'] {
			.${ListWrapper.base} {
				transform: scale(0);
				opacity: 0;
			}
		}

		&[data-placement^='top'] {
			.${ListWrapper.base} {
				transform-origin: bottom;
			}
		}
		&[data-placement^='bottom'] {
			.${ListWrapper.base} {
				transform-origin: top;
			}
		}
		&[data-placement^='left'] {
			.${ListWrapper.base} {
				transform-origin: right;
			}
		}
		&[data-placement^='right'] {
			.${ListWrapper.base} {
				transform-origin: left;
			}
		}
	`,
    hasDropdownAnimation: css `
		&[data-placement^='bottom'] {
			.${ListWrapper.base} {
				transform: translateY(-30px);
				opacity: 0;
			}
		}
		&[data-placement^='top'] {
			.${ListWrapper.base} {
				transform: translateY(30px);
				opacity: 0;
			}
		}

		&[data-status='initial'],
		&[data-status='close'] {
			.${ListWrapper.base} {
				opacity: 0;
			}
		}
		&[data-status='open'] {
			.${ListWrapper.base} {
				transform: translateY(0);
				opacity: 1;
			}
		}
	`,
    hasRightToLeftAnimation: css `
		&[data-placement^='bottom'],
		&[data-placement^='top'] {
			.${ListWrapper.base} {
				transform: translateX(100%);
				opacity: 0;
			}
		}

		&[data-status='initial'],
		&[data-status='close'] {
			.${ListWrapper.base} {
				transform: translateX(100%);
				opacity: 0;
			}
		}

		&[data-status='open'] {
			.${ListWrapper.base} {
				transform: translate(0%);
				opacity: 1;
			}
		}
	`,
    hasPaddingBottom: css `
		ul {
			&:after {
				pointer-events: none;
				content: '';

				position: absolute;
				z-index: 1;
				right: 0;
				bottom: 0;
				left: 0;

				display: block;

				width: 100%;
				height: 50px;
				border-radius: 8px;

				background: linear-gradient(transparent, rgb(var(--contextMenu-color-background)));
			}

			li {
				display: flex;
			}
		}
	`,
    isFullwidth: css `
		width: 100%;
	`,
    hasBottomBorder: css `
		border-bottom: var(--input-border-base) solid rgb(var(--contextMenu-color-border-item));
	`,
};
export const Arrow = {
    base: css `
		&& {
			fill: rgb(var(--contextMenu-color-pointer));
			path {
				fill: rgb(var(--contextMenu-color-pointer));
			}
		}
	`,
};
export const Label = {
    base: css `
		position: relative;
		padding: 10px;
		&:after {
			content: '';

			position: absolute;
			bottom: 1px;
			left: 0;

			width: 100%;
			border-bottom: 1px solid rgb(var(--contextMenu-color-border-item), 0.2);
		}
	`,
};
export const ChildWrapper = {
    base: css `
		border: var(--input-border-base) solid rgb(var(--contextMenu-color-border));
	`,
};
export const ChildContainer = {
    base: css `
		ul {
			.${ButtonRoot.base} {
				border: none;
				background: none;
				box-shadow: none;

				svg {
					path {
						fill: rgb(var(--button-square-color-label-idle)) !important;
					}
				}

				&:hover {
					@media (any-hover: hover), (any-pointer: fine) {
						svg {
							path {
								fill: rgb(var(--button-square-color-icon-hover)) !important;
							}
						}
					}
				}

				&.active {
					color: rgb(var(--button-square-color-icon-idle));
					svg {
						path {
							fill: rgb(var(--button-square-color-icon-idle)) !important;
						}
					}

					&:hover {
						@media (any-hover: hover), (any-pointer: fine) {
							color: rgb(var(--button-square-color-label-hover));
							svg {
								/* stylelint-disable-next-line -- We need to overwrite this specific element from the ChildTheme */
								path {
									fill: rgb(var(--button-square-color-icon-hover)) !important;
								}
							}
						}
					}
				}
			}
		}
	`,
};
